module.exports = __webpack_public_path__ + "static/media/291313.43e80c4c.png";